var map = {
	"./menu01.png": 562,
	"./menu02.png": 563,
	"./menu03.png": 564,
	"./menu04.png": 565,
	"./menu05.png": 566,
	"./menu06.png": 567,
	"./menu07.png": 568,
	"./menu08.png": 569,
	"./menu09.png": 570,
	"./menu10.png": 571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;